module.exports = __webpack_public_path__ + "static/img/core-2.7a038bc0.png";